<script lang="ts">
	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import { extractNonNull } from '../../../../utils/extractNonNull/extractNonNull';
	import type { ArticleTextType } from '../../types';

	interface Props {
		item: ArticleTextType;
	}

	let { item }: Props = $props();

	let safeItem = $derived(extractNonNull(item, ['content'], {}));
</script>

{#if safeItem}
	<div class="overrides">
		<LazyMarkdown
			source={item.contentTokens ?? safeItem.content}
			dataCy="blog-article"
			color="black"
		/>
	</div>
{/if}

<style>
	.overrides :global(h2) {
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.5rem;
		letter-spacing: 0;
	}

	.overrides :global(h2) > :global(span) {
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.5rem;
		letter-spacing: 0;
	}
</style>
